import CustomButton from 'components/atoms/CustomButton'
import ModalUser from 'components/molecules/user/ModalUser'
import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser'
import moment from 'moment'
import { Checkbox, Spin } from 'antd'
import { useTranslation } from 'react-i18next'

const styles = {
  title: 'text-black font-normal text-2xl', sub_title: 'text-base font-semibold', paragraph: 'list-disc list-inside'
}

export default function TCModalProfile({
                                         show,
                                         onClose,
                                         pp,                        // { privacy_policies, updated_at }
                                         tc,                        // { data,            updated_at }
                                         isFetching,

                                         /* marketing */
                                         initialMarketingAccepted = false,
                                         isFetchingMarketing = false,
                                         onToggleMarketing = async () => {
                                         }
                                       }) {
  const { t } = useTranslation()

  /* ---------- checkbox state ---------- */
  const [marketingAccepted, setMarketingAccepted] = useState(initialMarketingAccepted);
  const [savingMarketing, setSavingMarketing] = useState(false);

  useEffect(() => {
    if (show) {

      setMarketingAccepted(initialMarketingAccepted);
    }
  }, [show, initialMarketingAccepted]);


  const handleMarketingChange = async (e) => {
    const next = e.target.checked;
    setMarketingAccepted(next);
    setSavingMarketing(true);
    try {
      await onToggleMarketing(next);
    } catch (_) {
      // rollback UI se errore
      setMarketingAccepted(!next);
    } finally {
      setSavingMarketing(false);
    }
  };

  /* ---------- render helper ---------- */
  const renderBlocks = (arr = [], updatedAt, prefix) => arr.map(({ key, value }, idx) => {
    switch (key) {
      case 'title':
        return (<span key={`${prefix}-title-${idx}`} className={styles[key]}>
              {value} ({t('last updated')}: {moment(updatedAt).format('DD/MM/YYYY')})
            </span>)
      case 'sub_title':
        return (<span key={`${prefix}-sub-${idx}`} className={styles[key]}>
              {value}
            </span>)
      case 'paragraph':
        return <div key={`${prefix}-p-${idx}`}>{parse(value)}</div>
      default:
        return null
    }
  })

  /* ---------- UI ---------- */
  return (<ModalUser
      title={t('Privacy Policy & Terms and Conditions')}
      show={show}
      onClose={onClose}
    >
      {/* Testo PP + T&C */}
      <div className="h-96 overflow-y-auto flex flex-col gap-4">
        {isFetching ? (<div className="w-full h-full flex justify-center items-center">
            <Spin size="large" />
          </div>) : (<>
            {renderBlocks(pp?.privacy_policies ?? [], pp?.updated_at, 'pp')}
            {renderBlocks(tc?.data ?? [], tc?.updated_at, 'tc')}
          </>)}
      </div>

      {/* Checkbox marketing */}
      {!isFetching && (<div className="flex items-center gap-2 mt-6">
          <Checkbox
            checked={marketingAccepted}
            disabled={savingMarketing || isFetchingMarketing}
            onChange={handleMarketingChange}
          />
          <span className="text-xs font-normal text-[#828282] mt-2">{t('Signup.AcceptMarketing')}</span>
          {(savingMarketing || isFetchingMarketing) && (<Spin size="small" className="ml-2" />)}
        </div>)}

      {/* Solo bottone chiudi */}
      <div className="flex justify-end items-center gap-4 mt-4">
        <CustomButton buttonColor="secondary" onClick={onClose}>
          {t('Close')}
        </CustomButton>
      </div>
    </ModalUser>)
}
